export type ChatMessageProps = {
  id: string
  author: string
  comment: string
  dateTime: string
  isFromAdmin?: boolean
}

export default function ChatMessage(props: ChatMessageProps) {
  const { author, dateTime, comment, id, isFromAdmin } = props
  return (
    <div
      className={`${
        isFromAdmin ? 'float-left' : 'float-right '
      } relative clear-both mt-5 min-w-[25%] max-w-[75%] rounded-[20px] lg:max-w-[50%] `}
    >
      <span
        className={`${
          isFromAdmin ? 'float-left pl-2' : 'float-right pr-2'
        } Type-Small-Regular mb-2 text-70-grey`}
      >
        <div className='Type-Small-Bold inline'>{author}</div>, {dateTime}
      </span>
      <div
        id={id}
        className={`${
          isFromAdmin
            ? 'float-left rounded-l-none bg-off-white'
            : 'float-right rounded-r-none bg-purple-mist'
        } Type-Large-Regular relative clear-both rounded-[20px] py-5  px-5 `}
      >
        {comment}
      </div>
    </div>
  )
}
